/**
 * @generated SignedSource<<3af07fb96cf4d6d9e2ee654ec46c3ed8>>
 * @lightSyntaxTransform
 */

/* tslint:disable */
/* eslint-disable */
// @ts-nocheck

import { ConcreteRequest } from 'relay-runtime';
export type SetUserOnboardedInput = {
  clientMutationId?: string | null | undefined;
};
export type useSetUserOnboardedMutation$variables = {
  input: SetUserOnboardedInput;
};
export type useSetUserOnboardedMutation$data = {
  readonly setUserOnboarded: {
    readonly clientMutationId: string | null | undefined;
    readonly user: {
      readonly onboardedAt: any | null | undefined;
      readonly updatedAt: any;
    } | null | undefined;
  } | null | undefined;
};
export type useSetUserOnboardedMutation = {
  response: useSetUserOnboardedMutation$data;
  variables: useSetUserOnboardedMutation$variables;
};

const node: ConcreteRequest = (function(){
var v0 = [
  {
    "defaultValue": null,
    "kind": "LocalArgument",
    "name": "input"
  }
],
v1 = [
  {
    "kind": "Variable",
    "name": "input",
    "variableName": "input"
  }
],
v2 = {
  "alias": null,
  "args": null,
  "kind": "ScalarField",
  "name": "clientMutationId",
  "storageKey": null
},
v3 = {
  "alias": null,
  "args": null,
  "kind": "ScalarField",
  "name": "onboardedAt",
  "storageKey": null
},
v4 = {
  "alias": null,
  "args": null,
  "kind": "ScalarField",
  "name": "updatedAt",
  "storageKey": null
};
return {
  "fragment": {
    "argumentDefinitions": (v0/*:: as any*/),
    "kind": "Fragment",
    "metadata": null,
    "name": "useSetUserOnboardedMutation",
    "selections": [
      {
        "alias": null,
        "args": (v1/*:: as any*/),
        "concreteType": "SetUserOnboardedPayload",
        "kind": "LinkedField",
        "name": "setUserOnboarded",
        "plural": false,
        "selections": [
          (v2/*:: as any*/),
          {
            "alias": null,
            "args": null,
            "concreteType": "User",
            "kind": "LinkedField",
            "name": "user",
            "plural": false,
            "selections": [
              (v3/*:: as any*/),
              (v4/*:: as any*/)
            ],
            "storageKey": null
          }
        ],
        "storageKey": null
      }
    ],
    "type": "Mutation",
    "abstractKey": null
  },
  "kind": "Request",
  "operation": {
    "argumentDefinitions": (v0/*:: as any*/),
    "kind": "Operation",
    "name": "useSetUserOnboardedMutation",
    "selections": [
      {
        "alias": null,
        "args": (v1/*:: as any*/),
        "concreteType": "SetUserOnboardedPayload",
        "kind": "LinkedField",
        "name": "setUserOnboarded",
        "plural": false,
        "selections": [
          (v2/*:: as any*/),
          {
            "alias": null,
            "args": null,
            "concreteType": "User",
            "kind": "LinkedField",
            "name": "user",
            "plural": false,
            "selections": [
              (v3/*:: as any*/),
              (v4/*:: as any*/),
              {
                "alias": null,
                "args": null,
                "kind": "ScalarField",
                "name": "id",
                "storageKey": null
              }
            ],
            "storageKey": null
          }
        ],
        "storageKey": null
      }
    ]
  },
  "params": {
    "cacheID": "282de48bd43554e4e172179723462e9c",
    "id": null,
    "metadata": {},
    "name": "useSetUserOnboardedMutation",
    "operationKind": "mutation",
    "text": "mutation useSetUserOnboardedMutation(\n  $input: SetUserOnboardedInput!\n) {\n  setUserOnboarded(input: $input) {\n    clientMutationId\n    user {\n      onboardedAt\n      updatedAt\n      id\n    }\n  }\n}\n"
  }
};
})();

(node as any).hash = "7f60c649e422bc088e064f65048a3e6e";

export default node;
